import React from 'react';
import { Card } from '@/components/ui/card';

export default function LegendCard() {
  return (
    <Card className="p-4 mt-4">
      <h4 className="text-xs font-bold uppercase mb-2">Availability Legend</h4>
      <div className="grid grid-cols-3 gap-2">
        <div className="flex items-center gap-1.5">
          <div className="w-3 h-3 bg-green-100 border-2 border-green-700 rounded shrink-0"></div>
          <span className="text-xs">Available (60%+)</span>
        </div>
        <div className="flex items-center gap-1.5">
          <div className="w-3 h-3 bg-orange-100 border-2 border-orange-700 rounded shrink-0"></div>
          <span className="text-xs">Limited (1-40%)</span>
        </div>
        <div className="flex items-center gap-1.5">
          <div className="w-3 h-3 bg-red-100 border-2 border-red-700 rounded shrink-0"></div>
          <span className="text-xs">Fully Booked</span>
        </div>
      </div>
    </Card>
  );
}
